import Header from "@/components/Header";
import Hero from "@/components/Hero";
import VideoSection from "@/components/VideoSection";
import Reviews from "@/components/Reviews";
import Gallery from "@/components/Gallery";
import Services from "@/components/Services";
import WhyUs from "@/components/WhyUs";
import ServiceAreas from "@/components/ServiceAreas";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import JsonLd from "@/components/JsonLd";

const Home = ({ settings, content }) => {
  return (
    <div className="min-h-screen bg-white">
      <JsonLd settings={settings} />
      <Header />
      <main>
        <Hero settings={settings} content={content} />
        <VideoSection content={content} />
        <Reviews content={content} />
        <Gallery />
        <Services content={content} />
        <WhyUs />
        <ServiceAreas />
        <FinalCTA settings={settings} content={content} />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
